export default __webpack_public_path__ + "static/media/partner.d2a27de8.jpg";